import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

export const NOTIFY_ME_ON_PRODUCT_BACK_IN_STOCK_V2: DocumentNode = gql`
  mutation notifyMeOnProductBackInStockV2($email: String!, $sku: String!) {
    notifyMeOnProductBackInStockV2(email: $email, sku: $sku)
  }
`;
